import React from 'react';

const ErrorPage = () => {
    return (
        <div>
            <h1>Error: Page Not Found</h1>
            <p>Sorry, the page you are looking for does not exist.</p>
        </div>
    );
};

export default ErrorPage;
